export const REPORT_TYPE_EVENT = {
  REPORT_ADHOC_POSADAS_QUIZ_AND_GENERAL: {
    event: 'Send Adhoc Posadas Quiz and General Result Quiz by Classes Report',
    reportType: 'Adhoc Posadas Quiz and General Result Quiz by Classes Report',
  },
  REPORT_B2B_EVALUATIONS_CLASS_RESULTS: {
    event: 'Send Evaluations Class Results Report',
    reportType: 'Evaluations Class Results Report',
  },
  REPORT_B2B_EVALUATIONS_CLASS_DETAIL: {
    event: 'Send Evaluations Class Detail Report',
    reportType: 'Evaluations Class Detail Report',
  },
  REPORT_B2B_EVALUATIONS_GENERAL: {
    event: 'Send Evaluations General Report',
    reportType: 'Evaluations General Report',
  },
  REPORT_B2B_COURSES: {
    event: 'Generate Courses Report',
    reportType: 'Courses Report',
  },
  REPORT_B2B_ELEVATE_COURSES: {
    event: 'Generate Elevate Courses Report',
    reportType: 'Elevate Courses Report',
  },
  REPORT_B2B_GENERAL: {
    event: 'Send Report',
    reportType: 'General Report',
  },
  REPORT_B2B_LEADERS: {
    event: 'Send Report',
    reportType: 'Leader Report',
  },
  REPORT_B2B_LIVE_SESSIONS: {
    event: 'Send Live Sessions Report',
    reportType: 'Live Sessions Report',
  },
  REPORT_B2B_NOT_STUDYING_USERS: {
    event: 'Send Not-Studying Users Report',
    reportType: 'Not-Studying Users Report',
  },
  REPORT_B2B_PENDING_USERS: {
    event: 'Send Pending Users Report',
    reportType: 'Pending Users Report',
  },
  REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES: {
    event: 'Send Quiz Responses by Classes Report',
    reportType: 'Quiz Responses by Classes Report',
  },
  REPORT_B2B_RESULT_QUIZZ_BY_CLASSES: {
    event: 'Send Quiz Results by Classes Report',
    reportType: 'Quiz Results by Classes Report',
  },
  REPORT_B2B_TRACKS: {
    event: 'Send Report',
    reportType: 'Tracks Report',
  },
  REPORT_B2B_USERS: {
    event: 'Generate Administration Report',
    reportType: 'Users Report',
  },
  REPORT_CENTRALIZED_USERS: {
    event: 'Send Centralized Users Report',
    reportType: 'Centralized Users Report',
  },
};
